export default __webpack_public_path__ + "static/media/img_muslinTwo_rg.e5e0a5be.jpg";